import { render, staticRenderFns } from "./CustomerSearch.vue?vue&type=template&id=a637ef72&scoped=true&"
import script from "./CustomerSearch.vue?vue&type=script&lang=ts&"
export * from "./CustomerSearch.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerSearch.vue?vue&type=style&index=0&id=a637ef72&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a637ef72",
  null
  
)

export default component.exports